import { useSelector } from "react-redux";
import { selectCreateStep } from "../../../store/massiveDocumentCreate/selectors/selectCreateStep";
import { DocumentCreateFirstStep } from "./DocumentCreateFirstStep";
import { DocumentCreateThirdStep } from "./DocumentCreateThirdStep";
import { PreviewInformationTable } from "./PreviewInformationTable";

const DocumentCreateForm: React.FC = () => {
  const createStep = useSelector(selectCreateStep);
  return (
    <>
      {createStep === 1 && <DocumentCreateFirstStep />}
      {createStep === 2 && <DocumentCreateThirdStep />}
      {createStep === 3 && <PreviewInformationTable />}
    </>
  );
};

export default DocumentCreateForm;
